import React from "react";
import "./ViewCareer.scss";
import JobOpeningService from "Pages/AdministratorDashboard/APIServices/JopOpeningService";
import { EmploymentTypeEnumLabel } from "Constants/Enums/EmploymentTypeEnum";

function JobSideDetail() {
  const { jobDetails } = JobOpeningService();
  // Assign job details based on job nam
  return (
    <>
      {jobDetails && (
        <div className="card-below-content">
          <div className="detail">
            <p className="location">Location</p>
            <p className="loc-city">{jobDetails.jobLocationType}</p>
            <hr className="hr-viewcareer" style={{ marginTop: "1px" }}></hr>
          </div>
          <div className="detail">
            <p className="location">Department</p>
            <p className="loc-city">{jobDetails.department}</p>
            <hr className="hr-viewcareer" style={{ marginTop: "1px" }}></hr>
          </div>
          <div className="detail">
            <p className="location">Employment Type</p>
            <p className="loc-city">
              {EmploymentTypeEnumLabel[jobDetails.employmentType] ?? jobDetails.employmentType}
            </p>
            <hr className="hr-viewcareer" style={{ marginTop: "1px" }}></hr>
          </div>
          <div className="detail">
            <p className="location">Minimum Experience</p>
            <p className="loc-city">{jobDetails.maximumExperience}</p>
            <hr className="hr-viewcareer" style={{ marginTop: "1px" }}></hr>
          </div>
          <div className="detail">
            <p className="location">Compensation</p>
            <p className="loc-city">{jobDetails.compensation}</p>
            <hr className="hr-viewcareer" style={{ marginTop: "1px" }}></hr>
          </div>
        </div>
      )}
    </>
  );
}

export default JobSideDetail;
